import { Injectable, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthService } from '@bya/auth/services/authentication.service';
import { FuseNavigationItem } from '@fuse/types';
import { concat } from 'rxjs/operators';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { navigation } from './navigation';

@Injectable({
  providedIn: 'root'
})
export class FilterNavigationService  {

    constructor(private authService: AuthService, private _fuseNavigationService: FuseNavigationService) { }

    arbol: FuseNavigationItem[];

    subscribeauthNavStatus$() {
        
        this.authService.authNavStatus$.subscribe(reportAuth => {
            this.arbol = JSON.parse(JSON.stringify(navigation));  
            
            //this._fuseNavigationService.unregister('main');

            this.filtradoPorNivel(this.arbol, reportAuth.user, reportAuth.status, reportAuth.origen);
            if (this._fuseNavigationService.exitsNavigation('main'))
            {
                this._fuseNavigationService.unregister('main');
            }
            this._fuseNavigationService.register('main', this.arbol);

            this._fuseNavigationService.setCurrentNavigation('main');
          
        });

    }

    filtradoPorNivel(arbol: FuseNavigationItem[], user: any, status: string, origen: string) {
        
        var eliminar: Array<FuseNavigationItem> = [];
        
        if (user) {

            if (!this.authService.anyRole())
            {
                arbol.forEach(element => {
                    eliminar.push(element);
                });
                eliminar.forEach(element => {
                    this.deleteItem(arbol, element);
                });
                return;
            }

            arbol.forEach(element => {
                if (element.type != "item") {
                    this.filtradoPorNivel(element.children, user, status, origen);
                    if (element.children.length == 0) eliminar.push(element);
                }
                else {
                    if (element.roles) {
                        if (!this.authService.hasRoleInUser(user, element.roles)) {
                            eliminar.push(element);
                        }
                    }
                }
            });
            /*(Si está autenticado)
            Luego de llenar el arbol de navegación se remueve el menu de login*/
            eliminar.push(arbol.find((t)=>{return t.id == 'login'}));
        }
        else if (status == "false") {
            arbol.forEach(element => {
                if (element.type != "item") {
                    this.filtradoPorNivel(element.children, user, status, origen);
                    if (element.children.length == 0) eliminar.push(element);
                }
                else {
                    if (element.roles) {
                        eliminar.push(element);
                    }
                        
                }
            });
            /** Como no esta autenticado el usuario eliminamos este item **/
            eliminar.push(arbol.find((t)=>{return t.id == 'consultaOrdenesPago'}));
        }
       
        eliminar.forEach(element => {
            this.deleteItem(arbol, element);
        });

    }


    private deleteItem(elementos: FuseNavigationItem[], item: FuseNavigationItem) {
        const index: number = elementos.indexOf(item);
        if (index !== -1) {
            elementos.splice(index, 1);
        }
    }

}
